import { userService } from '@/services/user.service'
import i18n from '@/i18n'

export default {
    name: 'UserDialogDataTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            //required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
      
        // model para el formulario
        isValidForm: false,
        // para validación de username
        actualUsername: null,
        // errores del username
        usernameError: [],
        // mostrar/ocultar contraseñas
        showPassword: false,
        showRepeatPassword: false
    }),
    computed: {
    },
    created () {
        this.actualUsername = this.model.username
    },
    mounted () {
    },
    methods: {
        /**
         * Mensaje de error cuando el nombre de usuario está duplicado
         */
        usernameDuplicatedMethod() {
            if (this.model.username === this.actualUsername) return
            userService.validateUsername(this.model.username).then(response => {
                if (response) {
                    this.usernameError.push(`${i18n.t('user.duplicate')}`)
                } else {
                    this.usernameError = []
                }
            })
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.userDialogDataTabForm) {
                this.$refs.userDialogDataTabForm.resetValidation()
            }
        }
    }
}
